import { render, staticRenderFns } from "./inbox.vue?vue&type=template&id=471530c0&"
import script from "./inbox.vue?vue&type=script&lang=js&"
export * from "./inbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QPageContainer,QList,QItem,QItemSection,QItemLabel,QInput,QIcon,QAvatar,QSeparator,QPagination,Ripple} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QPageContainer,QList,QItem,QItemSection,QItemLabel,QInput,QIcon,QAvatar,QSeparator,QPagination})
component.options.directives = Object.assign(Object.create(component.options.directives || null), component.options.directives || {}, {Ripple})
